/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react'
import Tabs from 'builder/components/Tabs'
import { useCategoryTabsContext } from '..'
import { ConnectorLine, Container } from '../styles'

export default function CategoryTabList(props: {
  items: { id: string; label: string; element: React.ReactNode }[]
}) {
  const { activeTab } = useCategoryTabsContext()

  const activeIndex = props.items.findIndex(i => i.id === activeTab)
  const itemsWithLines = props.items.flatMap((child, index) => {
    const showLine = index < props.items.length - 1
    const isBeforeActive = index === activeIndex - 1
    const isAfterActive = index === activeIndex
    const isGradientLine = isBeforeActive || isAfterActive
    const childElement = child.element

    return showLine
      ? [
          childElement,
          <ConnectorLine
            key={`line-${index}`}
            layout="horizontal"
            gradient={
              isGradientLine ? (isBeforeActive ? 'right-to-left' : 'left-to-right') : undefined
            }
          />,
        ]
      : [childElement]
  })

  return (
    // @ts-ignore
    <Tabs Container={Container} disableSelector={true}>
      {itemsWithLines}
    </Tabs>
  )
}
